// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1PVz7","paramInput":"JobSimulator_paramInput__BvneN","input":"JobSimulator_input__2q34n"};